import React from 'react'
import { useNavigate } from 'react-router-dom'
import FloatButton from './ui/FloatButton'

const BackToDash = () => {

    const navigate = useNavigate()

  return (
    <FloatButton handleClick={() => navigate("/")} width="200px">
    Back to Dashboard
  </FloatButton>
  )
}

export default BackToDash